// Shared roving-focus keyboard helper (Wave 2, INSTR-VW-APPSHELL-PROD-IMPLEMENT-007 §2.1/§2.2).
// Moves DOM focus among a composite widget's items on Arrow/Home/End — WAI-ARIA roving pattern.
// Focus-only: activation stays on the item's own click/Enter (native button semantics), so no
// activation behaviour changes. Returns true when the key was handled (caller preventDefaults).
export function moveRovingFocus(
  container: HTMLElement | null,
  key: string,
  selector: string,
  orientation: "horizontal" | "vertical",
): boolean {
  if (!container) return false;
  const forward = orientation === "horizontal" ? "ArrowRight" : "ArrowDown";
  const backward = orientation === "horizontal" ? "ArrowLeft" : "ArrowUp";
  if (key !== forward && key !== backward && key !== "Home" && key !== "End") return false;

  const items = Array.from(container.querySelectorAll<HTMLElement>(selector)).filter(
    (el) => !el.hasAttribute("disabled") && el.getAttribute("aria-disabled") !== "true",
  );
  if (items.length === 0) return false;

  const active = document.activeElement;
  const current = items.findIndex((el) => el === active);
  let next: number;
  if (key === "Home") next = 0;
  else if (key === "End") next = items.length - 1;
  else if (current === -1) next = key === forward ? 0 : items.length - 1; // enter the composite
  else if (key === forward) next = (current + 1) % items.length;
  else next = (current - 1 + items.length) % items.length;

  items[next].focus();
  return true;
}
